import { render, staticRenderFns } from "./ResetPasswordHeader.vue?vue&type=template&id=6e11e305&scoped=true"
import script from "./ResetPasswordHeader.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e11e305",
  null
  
)

export default component.exports